'use strict';

export default class SearchResults extends React.Component {
    handleSelectFlight(e, flight) {
        e.preventDefault();
        const {routes} = this.props;
        openFlight({flight, routes});
    }

    getSortedItems() {
        const items = [...this.props.items];
        items.sort((a, b) => (a.price_sort ? parseInt(a.price_sort) : 0) - (b.price_sort ? parseInt(b.price_sort) : 0));
        return items;
    }

    getItemPrice(item) {
        const {routes} = this.props;
        if(!!item.priceBase && !!item.seatsPaid && !!item.priceAdd) {
            return item.priceBase + Math.max(routes[0].seats - item.seatsPaid, 0) * item.priceAdd;
        }
        return item.price;
    }

    renderFacilities(item) {
        const aircraft = item.aircraft;
        const isBJ = !!item.listTitle;
        let items = [];

        if(item.type === 'shuttle') {
            items.push({value: tMsg('Питание VIP')});
            items.push({value: tMsg('Стюардесса')});
            if(!isBJ) items.push({value: tMsg('VIP-зал')});
            items.push({value: tMsg('Алкоголь')});
            items.push({value: 'WC'});
            if(isBJ) items.push({value: tMsg('Животное')});
        } else {
            items = [
                {title: tMsg('Мест'), value: aircraft.seats},
                {title: tMsg('Питание'), value: aircraft.facilities.food},
                {title: tMsg('Стюардесса'), value: aircraft.facilities.stewardess},
                {title: tMsg('Багаж'), value: aircraft.facilities.baggage},
                {title: tMsg('Выс. салона'), value: aircraft.height},
            ]
        }

        return <div className="flight-row">
            {items.map((item, index) => <div key={`fa_${item.id}_${index}`} className="flight-info">
                {!!item.title && <span>{item.title}</span>}
                {item.value}
            </div>)}
        </div>
    }

    render() {
        const items = this.getSortedItems();

        return <div className="results">
            {items.map((item, index) => {
                const image = Array.isArray(item.images) && item.images.length > 0 ? item.images[0]['280x170'] : null;
                const key = item.type + item.id + index;

                let subTitle = item.aircraft.class !== item.aircraft.title ? item.aircraft.class : null;
                let extraTitles = item.extraTitles || [];
                if(item.aircraft.examples) subTitle = item.aircraft.examples.join(', ');
                const showPrice = !item.price_by_request

                let title = item.aircraft.title;
                if(item.listTitle) {
                    title = item.listTitle.join('<span> + </span>');
                    subTitle = null;
                }

                return <div className="flight" key={key}>
                    <a href='#' className="flight-link" onClick={e => this.handleSelectFlight(e, item)}/>
                    <div className="flight-img">
                        <img src={image} alt=""/>
                    </div>
                    <div className="flight-desc">
                        <div className="flight-title">
                            <h3 dangerouslySetInnerHTML={{__html: title}}/>
                            {item.tags && <div className="flight-tag">
                                {item.tags.map(tag => <span>{tag}</span>)}
                            </div>}
                        </div>
                        <div className="flight-planes">
                            {subTitle && <div className='flight-planes__place'>{subTitle}</div>}
                            {!!item.passengers && <div className='flight-planes__place'>
                                <span>{item.passengers.formatSeats()}</span> {tMsg('из')} {item.max_passengers}
                            </div>}
                            {extraTitles.map(({title, value}) => <div className='flight-planes__place'>{value}</div>)}
                        </div>
                        {this.renderFacilities(item)}
                    </div>
                    <div className="flight-control">
                        {!!item.discount && <div className="flight-label">
                            <span>
                                <i className="icon-percent"/>
                            </span>
                        </div>}
                        <div className="flight-type">
                            {item.fType}
                        </div>
                        <div className="flight-price">
                            {!showPrice && <div>{tMsg('Цена по запросу')}</div>}
                            {showPrice && !!item.pricePrefix && item.pricePrefix}
                            {showPrice && this.getItemPrice(item).formatPrice(item.currency)}
                            {showPrice && !!item.pricePerSeat && <span>{tMsg('за место')}</span>}
                        </div>
                    </div>
                </div>
            })}
        </div>
    }
}
